




import { Component, Mixins } from "vue-property-decorator";
import { DomainRegistry } from "../../../domain";
import { ContentSource } from "../../../domain/drawing";
import { ISourcePrintable, ISourcePrinterSpecifiable } from "..";

@Component({
})
export default class AssistantPdfPrinter extends Mixins() implements ISourcePrintable, ISourcePrinterSpecifiable {
  printSource(source: string, copies: number, shouldSelectPrinter: boolean, shouldPrintWatermarkForcibly: boolean, launchRequestKey: string): void {
    if (source === "") {
      return;
    }
    const service = DomainRegistry.localhost.getPrinterService();
    const content = new ContentSource(source);
    service.print(content, copies, shouldSelectPrinter, shouldPrintWatermarkForcibly, launchRequestKey);
  }

  printSourceTo(source: string, printerName: string, copies: number, launchRequestKey: string): void {
    if (source === "") {
      return;
    }
    const service = DomainRegistry.localhost.getPrinterService();
    const content = new ContentSource(source);
    service.printTo(content, printerName, copies, launchRequestKey);
  }
}
